import React from 'react'
import Index from '../../components/index/Index';

function Home() {
  return (
	<Index/>
  )
}

export default Home